import { gql } from '@apollo/client';

export const tenantConfigFragment = {
  tenantConfigItem: gql`
    fragment TenantConfigItem on TenantConfig {
      isEquipmentChangeControlUsed
      isEquipmentHoldAutoAssigned
      wrapZoneDefinitionLevel
      isOwnerEnforced
      isEquipmentTypeAllowed
      isDefaultNumberingUsed
      isDeletedPRComponentKept
      isInferringCableAllowed
      isTermByEquipmentAllowed
      revNoteDefinitionLevel
      isVirtualRacewayAllowed
      isRacewayWPUCalculated
      isCableChangeControlUsed
      isRacewayChangeControlUsed
      isJumperChangeControlUsed
      isCableHoldAutoAssigned
      isJumperHoldAutoAssigned
      isRacewayHoldAutoAssigned
      isTermHoldAutoAssigned
      isMetricUnitsOfMeasureUsed
      isMultipleFromToAllowed
      racewayDefaultMaxWPU
      isReservedRwayWidthAllowed
      isBlankSGAllowed
      isCableGlandUsed
      isChkrApprovalAllowed
      isChangeControlUsed
      isToWireUsed
      isWireDescAllowed
      termCodesLevel
      isTermCodesUsed
      maxWiresPerPoint
      shieldDesignator
      groundDesignator
      isConstrNotesAllowed
    }
  `,
};

export const GET_USER_ACCOUNT_BY_AUTH = gql`
  ${tenantConfigFragment.tenantConfigItem}
  query userAccountByAuth {
    userAccountByAuth {
      id
      nameFirst
      nameLast
      nameMiddle
      email
      upn
      loginName
      isActive
      defaultProjectId
      defaultProject {
        id
        name
        jobNumber
        subJobNumber
        alternateLanguageCode
      }
      roles {
        id
        roleName
      }
      permissions {
        id
        permissionName
      }
      tenantConfig {
        ...TenantConfigItem
      }
      userAccountProjects {
        id
        projectId
        isFavorite
        useAlternateLanguage
      }
      userAccountPhoto {
        id
        photo
      }
    }
  }
`;
export const UPDATE_USER_DEFAULT_PROJECT = gql`
  mutation updateUserDefaultProject($updateUserDefaultProjectInput: UpdateUserDefaultProjectInput!) {
    updateUserDefaultProject(updateUserDefaultProjectInput: $updateUserDefaultProjectInput) {
      userAccount {
        id
        defaultProjectId
      }
    }
  }
`;

export const UPDATE_USER_ACCOUNT_PROJECT = gql`
  mutation updateUserAccountProject($updateUserAccountProjectInput: UpdateUserAccountProjectInput!) {
    updateUserAccountProject(updateUserAccountProjectInput: $updateUserAccountProjectInput) {
      userAccountProject {
        id
        projectId
        userAccountId
        isFavorite
        useAlternateLanguage
        updatedTime
        updatedBy
        project {
          id
          name
        }
      }
      errors
    }
  }
`;

export const GET_USER_ACCOUNT_PROJECTS = gql`
  query SearchUserAccountProjects($searchInput: SearchInput) {
    searchUserAccountProjects(searchInput: $searchInput) {
      items {
        id
        projectId
        userAccountId
        isFavorite
        useAlternateLanguage
        project {
          id
          name
          jobNumber
          subJobNumber
          logo
        }
      }
    }
  }
`;

export const projectFragments = {
  projectItem: gql`
    fragment ProjectItem on Project {
      id
      alternateLanguageCode
      changeControl
      uomWidth
      uomWeight
      uomLength
      subJobNumber
      jobNumber
      name
      title
      logo
      wrapZoneLevel
      isMetricUomUsed
      revNoteLevel
      isConstrNotesAllowed
      isBlankSgAllowed
      isDelPrCompKept
      isChkrApprovalAllowed
      isExtendedBarcodeUsed
      isOwnerEnforced
      autoAssignHold
      feedbackLengthThreshhold
      isActive
      isInstEquipTypeAllowed
      isMultiFromToAllowed
      isCableGlandUsed
      cableRouteContChkLevel
      inferredViaTag
      isVirtualRwayAllowed
      isReservedWidthAllowed
      isRwayWpuCalculated
      rwayDefMaxWpu
      om7MultiplierLadder
      om7MultiplierSolidBtm
      maxConduitFill1
      maxConduitFill2
      maxConduitFill3
      maxWiresPerPoint
      shieldDesignator
      groundDesignator
      isToWireUsed
      isWireDescAllowed
      isInstEquipTermsAllowed
      isSpareNumberingOff
      isInstDefNumUsed
      isInstInferCableAllowed
      isInstWireTagPropagated
      termCodesLevel
      spareNumberExceptions
      cableDefaultLength
      changeSinceDesignator
      isFromToSorted
      engineeringStatus
      checkedBy
      checkedTime
      approvedBy
      approvedTime
      preparedBy
      preparedTime
      updatedBy
      updatedTime
      approvedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      checkedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      preparedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      updatedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
    }
  `,
};

export const GET_PROJECT_BY_ID = gql`
  ${projectFragments.projectItem}
  query ProjectById($id: ID!) {
    projectById(id: $id) {
      ...ProjectItem
    }
  }
`;

export const UPDATE_PROJECT = gql`
  ${projectFragments.projectItem}
  mutation UpdateProject($updateProjectInput: UpdateProjectInput!) {
    updateProject(updateProjectInput: $updateProjectInput) {
      project {
        ...ProjectItem
      }
      errors
      infos
    }
  }
`;

export const ISSUE_PROJECTS = gql`
  ${projectFragments.projectItem}
  mutation IssueProjects($issueProjectsInput: [IssueProjectInput!]!) {
    issueProjects(issueProjectsInput: $issueProjectsInput) {
      projects {
        ...ProjectItem
      }
      errors {
        tag: name
        messageKeys
      }
    }
  }
`;

export const GET_TENANT_CONFIG_BY_AUTH = gql`
  ${tenantConfigFragment.tenantConfigItem}
  query userAccountByAuth {
    userAccountByAuth {
      id
      tenantConfig {
        ...TenantConfigItem
      }
    }
  }
`;
